import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { UR_COMMERCIAL_GROUP } from '../../../../../Utils/Constants';


const headerData = [
  { id: 'brand', label: 'MARCA' },
  { id: 'model', label: 'MODELO' },
  { id: 'announcedoptionals', label: 'OPCIONAIS ANUNCIADOS' },
  { id: 'color', label: 'COR' },
  { id: 'reservationdate', label: 'DATA' },
  { id: 'customer', label: 'CLIENTE' },
  { id: 'owner', label: 'TITULAR' }
];

const styles = theme => ({
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  lastCellPadding: {
    paddingLeft: '16px',
    '&:last-child': {
      paddingLeft: '16px'
    }
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  },
  onHoldColor: {
    backgroundColor: '#ED8800'
  },
  minWidth: {
    minWidth: '180px'
  }
});


class RUReservationsOnHoldTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };


  render() {
    const { order, orderBy, classes } = this.props;
    const userRT = this.props.user.UserRoleType;

    return (
      <TableRow className={classNames(classes.headerHeight, classes.onHoldColor)} >
        {headerData.map(column => {
          return (
            <TableCell
              key={column.id}
              padding='none'
              sortDirection={orderBy === column.id ? order : false}
              className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, column.id === 'model' ? classes.minWidth : null,
                userRT.indexOf(UR_COMMERCIAL_GROUP) < 0 ? classes.lastCellPadding : classes.cellPadding
              )}
            >
              <TableSortLabel
                className={classes.tblHeadT}
                active={orderBy === column.id}
                direction={order}
                onClick={this.createSortHandler(column.id)}
                classes={{ icon: classes.tblSort }}
              >
                {column.label}
              </TableSortLabel>
            </TableCell>
          );
        }, this)}
        {userRT.indexOf(UR_COMMERCIAL_GROUP) < 0 ?
          null :
          <TableCell key={'icon'} padding='none' className={classes.tblBorder}></TableCell>
        }
      </TableRow>
    );

  }
}

RUReservationsOnHoldTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUReservationsOnHoldTableHeader));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsReservations/UsedRentalsAllReservations/UsedRentalsOnHoldReservations/RUReservationsOnHoldTableHeader.js